import { Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { filter, Observable, take } from 'rxjs';

import { SurveyCreationCoreApiActions } from '../survey-creation-core.actions';
// Cross-listen: the launch slice owns the sibling sync outcome.
import { SurveyCreationLaunchApiActions } from '../../launch/survey-creation-launch.actions';

export function saveSucceeded$(actions$: Actions): Observable<Action> {
  return actions$.pipe(
    ofType(
      SurveyCreationCoreApiActions.saveSurveySuccess,
      SurveyCreationCoreApiActions.saveSurveyFailure,
    ),
    take(1),
    filter(
      ({ type }) =>
        type === SurveyCreationCoreApiActions.saveSurveySuccess.type,
    ),
  );
}

// Traditional MC on the launch page: done once the siblings hold the copied settings too.
export function localeSyncSucceeded$(actions$: Actions): Observable<Action> {
  return actions$.pipe(
    ofType(
      SurveyCreationLaunchApiActions.localeSettingsSynced,
      SurveyCreationLaunchApiActions.localeSettingsSyncFailure,
      SurveyCreationCoreApiActions.saveSurveyFailure,
    ),
    take(1),
    filter(
      ({ type }) =>
        type === SurveyCreationLaunchApiActions.localeSettingsSynced.type,
    ),
  );
}
